module.exports = __webpack_public_path__ + "img/abstract-shapes-22.aaac6466.svg";